import styled from 'styled-components';

const Wrapper = styled.div`
  .titles {
    overflow-y: initial;

    .action-bar {
    display: flex;
    flex-direction: column;
    border-bottom: ${(props) => `1px solid ${props.theme.colors.outline}`};

    .bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 84px;
      padding: 16px;
      
      .assignment-container {
        height: 52px;
        display: flex;
        align-items: center;
        gap: 16px;
        
        .driver-overview {
          div {
            height: 52px;
            
            .avatar {
              height: 36px;
              width: 36px;
            }
            
            .description {
              justify-content: center;
            }
          }
          
          .driver-placeholder {
            padding: 17px;
            color: ${(props) => props.theme.colors.inactive};
            border: 1px dashed #3C3C3C;
            border-radius: 6px;

            font-size: 13px;
            line-height: 18px;
          }
        }
    }
    
    .buttons-container {
      display: flex;
      align-items: center;
      gap: 16px;

      font-size: 13px;
      font-family: ManropeBold, sans-serif;
      
      .cancel-btn {
        background: none;
      }
      
      .confirm-btn {
        height: 52px;
        padding: 8px 40px;
        
        background-color: ${(props) => props.theme.colors.main_cta};
        color: ${(props) => props.theme.colors.widget_background};

        &:hover {
          background-color: ${(props) => props.theme.colors.widget_hover_background};
          color: ${(props) => props.theme.colors.main_cta};
        }

        &:disabled {
          cursor: default;
          background-color: ${(props) => props.theme.colors.inactive};
          color: ${(props) => props.theme.colors.black};
        }
      }
    }
    }
    
    .error {
      text-align: right;
      padding: 8px 16px;
      color: ${(props) => props.theme.colors.red};
      font-family: ManropeLight, sans-serif;
    }
  }
  
    .drivers-toolbar {
      display: flex;
      gap: 8px;
      padding: 24px 16px 16px;
      
      h3 {
        flex: 1;
        font-size: 20px;
        color: ${(props) => props.theme.colors.text}
      }
    }
  }

  .drivers-list {
    height: 60vh;
    overflow-y: scroll;
    padding: 16px;

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.background_dashboard};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme.colors.inactive};
      border-radius: 20px;
      border: 3px solid ${(props) => props.theme.colors.background_dashboard};
    }

    .list-container {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  .info {
      padding: 16px;
      font-size: 13px;
      font-family: Manrope, sans-serif;
      color: ${(props) => props.theme.colors.main_cta};
  }
`;

const DriverWrapper = styled.li`
  height: 84px;
  width: 100%;
  min-width: 988px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  
  .tags-container {
    display: flex;
    gap: 16px;
  }

  .buttons-container {
    margin-left: 16px;
  }
  
  &:hover {
    cursor: pointer;
    background: ${(props) => props.theme.colors.item_list_hover};
    transition: all .2s ease-in;
    .title {
      color: ${(props) => props.theme.colors.main_cta};
    }
  }

  input[type="radio"]{
    display:none;
  }
  
  label {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 8px;
    
    div {
      margin-right: 8px;
    }
  }

  .checkbox {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin: 0 8px -4px 0; 
    position: relative;
    
    &:before {
      transition: all .3s ease-in-out;
      content: "";
      position: absolute;
      z-index: 1;
      width: 16px;
      height: 16px;
      background: transparent;
      border: 1px solid ${(props) => props.theme.colors.inactive};
    }
    
    &:after {
      transition: all .3s ease-in-out;
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      background: transparent;
      z-index: 0;
      border: none;
    }
  }

  input[type="radio"] + label .checkbox {
    &:before,
    &:after {
      border-radius: 50%;
    }
  }

  input[type="radio"]:checked + label .checkbox{
    &:after {
      width: 16px;
      height: 16px;
      background: ${(props) => props.theme.colors.main_cta};
      transition: all .2s ease-in;
    }
  }

  input[type="radio"]:checked + label .checkbox{
    &:before {
      left: 5px;
      top: 2px;
      width: 6px;
      height: 11px;
      border: solid ${(props) => props.theme.colors.inactive};
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }

  .no-face {
    color: red;
  }
`;

export default { Wrapper, DriverWrapper };
